import axios from 'axios'
import {  Message } from 'element-ui'
import store from '@/store'
const codes = {
  SUCCESS: 200,
  EXPIRED: [401]
}

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000 * 60 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    // let each request carry token
    // ['X-Token'] is a custom headers key
    // please modify it according to the actual situation
    // config.headers[process.env.VUE_APP_TOKEN || 'authorization'] = store.state.token || ''
    return config
  },
  error => {
    // do something with request error
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    if (response.config.origin) { return response }
    // if the custom code is not 0, it is judged as an error.
    if (+res.code !== codes.SUCCESS) {
      Message({
        message: res.msg || '未知错误',
        type: 'error',
        duration: 5 * 1000
      })

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (codes.EXPIRED.indexOf(+res.code) !== -1) {
        // to re-login
        store.commit('removeToken')
      }
      return Promise.reject(new Error(res.msg || '系统未知错误'))
    } else {
      return res.data
    }
  },
  error => {
    return Promise.reject(error)
  }
)
export function mock(api, time) {
  let _resolve
  const promise = new Promise((resolve) => {
    _resolve = resolve
  })
  setTimeout(() => {
    if (api.mockData && +api.mockData.code === 200) {
      _resolve(api.mockData.data)
    } else {
      _resolve(api.mockData)
    }
  }, time || 500)
  return promise
}
/**
 *
 * @param {*} api
 * @param {*} args 一个参数对象
 * // 想法：封装一个正常情况的返回，再给个处理原始返回的逻辑
 */
export default async function (api, args) {
  const isMock = api.mock
  api.url = api.path
  if (api.method.toLowerCase() === 'get') {
    api.params = args
  } else if (api.method.toLowerCase() === 'post') {
    api.data = args
  }
  return isMock ? await mock(api) : await service(api)
}

